import React, {Component} from 'react';
import PropTypes from "prop-types";
import EmailEditor from './EmailEditor';

class PeopleAdd extends Component {
    state = {
        email: '',
        course: '',
        status: ''
    };

    //Renders
    renderPanelAdd = () => (
        <div className="panel customPanel">
            <div className="panel-heading border-bottom">
                <h3 className="panel-title text-uppercase font-400">
                    <span className="font-16">
                        <i className="zmdi zmdi-plus-circle"/>
                        Add People
                    </span>
                </h3>
            </div>
            <div className="panel-body">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group sm-bottom0">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={(e) => {
                                    e.preventDefault();
                                    this.setState({email: e.target.value})
                                }}
                            />
                            {this.props.error &&
                            <div>{this.props.error}</div>
                            }
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <div className="form-group sm-bottom0">
                            {this.renderSelectStatus()}
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <div className="form-group sm-bottom0">
                            {this.renderSelectCourse()}
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <div className="form-group sm-bottom0">
                            <input
                                type="submit"
                                className="btn btn-primary btn-block"
                                value="Approve"
                                onClick={() => {
                                    this.props.addUserToCourse({courseId: this.state.course, email: this.state.email, role: this.state.status}, this.props.user.userId, this.props.user.id);
                                    this.setState({
                                        email: '',
                                        course: '',
                                        status: ''
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    renderRequests = () => (
        <div className="panel customPanel">
            <div className="panel-heading border-bottom">
                <h3 className="panel-title text-uppercase font-400">
                    <span className="font-16">
                        <i className="zmdi zmdi-check-all"/>
                        Requests
                    </span>
                </h3>
            </div>
            <div className="panel-body no-padding" style={{maxHeight: 300, overflowY: "auto"}}>
                <table className="table table-striped table-bordered sm-bottom0">
                    <tbody>
                        {this.renderRequestsTable()}
                    </tbody>
                </table>
            </div>
        </div>
    );

    renderRequestsTable = () => (
        
        this.props.pending.map(item => {
            if (item) {
                if(item.status === 'pending') {
                    return (
                        <tr
                            key={item.id}
                            className="row"
                        >
                            <td className="col-sm-6 v-middle">
                                {item.Profile ? item.Profile.name ? item.Profile.name : item.Profile.email : ''}
                            </td>
                            <td className="col-sm-2 v-middle">
                                {item.status}
                            </td>
                            <td className="col-sm-2 v-middle">
                                {item.Course ? item.Course.name : ''}
                            </td>
                            <td className="col-sm-2">
                                <div className="form-group sm-bottom0">
                                    <a
                                        role="button"
                                        className="btn btn-default"
                                        onClick={() => this.props.cancelRequests(item.id, this.props.user.id)}
                                    >
                                        Cancel
                                    </a>
                                    <a
                                        role="button"
                                        className="btn btn-primary"
                                        onClick={() => this.props.approveRequest(item.id, this.props.user.id)}
                                    >
                                        Approve
                                    </a>
                                </div>
                            </td>
                        </tr>
                    )
                }else{
                    return null;
                }
            }else{
                return null;
            }
        })
             

    );

    renderSelectCourse = () => (
        <select
            className="form-control"
            value={this.state.course}
            onChange={(e) => {
                e.preventDefault();
                this.setState({course: e.target.value});
            }}
        >
            <option value="">Select Course</option>
            {this.props.courses.map(course => {
                return (
                    <option value={course.id}>{course.name}</option>
                )
            })}
        </select>
    );

    renderSelectStatus = () => (
        <select
            className="form-control"
            value={this.state.status}
            onChange={(e) => {
                e.preventDefault();
                this.setState({status: e.target.value});
            }}
        >
            {this.renderOption('', 'What do they do?')}
            {this.renderOption('student', 'Student')}
            {this.renderOption('instructor', 'Instructor')}
            {this.renderOption('admin', 'Administrator')}
        </select>
    );

    renderOption = (value, title) => (
        <option
            value={value}
        >
            {title}
        </option>
    );

    //Lifecycle
    componentDidMount() {
        this.props.getRequestsData();
        this.props.onLoadCourses(this.props.user.userId, this.props.user.user.Profile.CourseUser, this.props.user.id);
        this.props.getPendingRequests(this.props.user.id);

    };

    saveEmail = (courses) => {
        this.props.updateCourses(courses, this.props.user.userId, this.props.user.user.Profile.CourseUser, this.props.user.id);

    }

    render() {

        return (
            <div className="panel customPanel no-bg flat">
                <div className="panel-body">
                    <h3 className="font-300 sm-top0">
                        99point9 Portal Access
                    </h3>
                    <p>
                        Here is where you grant students and teaches access to the portal
                    </p>
                    {
                        this.props &&
                        this.renderPanelAdd()
                    }
                    {
                        this.props.courses &&
                        this.renderRequests()
                    }

                    {this.props.courses.length > 0 &&
                    <EmailEditor
                        courses={this.props.courses}
                        saveEmail={(courses) => this.saveEmail(courses)}
                    />
                    }
                </div>
            </div>
        )
    }
}

PeopleAdd.propTypes = {
    request: PropTypes.array,
    getRequestsData: PropTypes.func.isRequired,
    cancelRequests: PropTypes.func,
    addPeople: PropTypes.func
};

export default PeopleAdd;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/PeopleAdd.js